import { connectResources } from '@ds-frontend/resource'
import get from 'lodash/get'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import { compose } from 'redux'

import QuoteListContainer from './QuoteListContainer'


export default compose(
  withRouter,
  connect((_, props) => ({
    uuid: get(props, 'router.query.id'),
  })),
  connectResources({
    endpoint: 'api/v2/public/quotes/:uuid',
    namespace: 'quoteList',
  }),
)(QuoteListContainer)
